
import { Component, Vue } from 'vue-property-decorator';

import Form17ProcessHeader from "@/components/process/Form17/components/Form17ProcessHeader.vue";
import { form17StatusInfoType } from '@/types/Information/Form17';

@Component({
    components:{
        Form17ProcessHeader
    }
})
export default class CancelSubmitForm17 extends Vue {

    stepsCompleted = {} as form17StatusInfoType;  
    mountedData = false;     

    mounted() {

        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
